import { useEffect, useState } from 'react';
import type { StaticImageData } from 'next/image';

interface SvgIconProps {
  src: string | StaticImageData;
  className?: string;
  size?: number;
}

/**
 * 通用 SVG 图标组件
 * 支持 URL 字符串或 StaticImageData（SVG 文件导入）
 * 内联渲染 SVG 以支持 currentColor
 */
const SvgIcon = ({ src, className, size = 16 }: SvgIconProps) => {
  const [svgContent, setSvgContent] = useState<string | null>(null);

  // 获取实际的 URL
  const url = typeof src === 'string' ? src : src.src;

  useEffect(() => {
    // 只处理 SVG 文件
    if (!url.endsWith('.svg')) {
      return;
    }

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        // 移除 XML 声明和注释，只保留 SVG 标签
        const svgMatch = text.match(/<svg[\s\S]*<\/svg>/i);
        if (svgMatch) {
          // 替换 width 和 height 属性
          const svg = svgMatch[0]
            .replace(/width="[^"]*"/, `width="${size}"`)
            .replace(/height="[^"]*"/, `height="${size}"`);
          setSvgContent(svg);
        }
      })
      .catch(() => {
        setSvgContent(null);
      });
  }, [url, size]);

  // 如果不是 SVG 或加载失败，使用 img 标签
  if (!svgContent) {
    return <img src={url} alt="" width={size} height={size} className={className} />;
  }

  // 内联渲染 SVG
  return <span className={className} dangerouslySetInnerHTML={{ __html: svgContent }} />;
};

export default SvgIcon;
